import { CallLogFileHandler, CallLogParseResult } from '../../models/callLogFileHandler';
import { csvCallLogFileHandler } from './csvCallLogFileHandler';
import { getFileExtension } from '../utilities';
import { xlsxCallLogFileHandler } from './xlsxCallLogFileHandler';

const handlers: CallLogFileHandler[] = [
	csvCallLogFileHandler,
	xlsxCallLogFileHandler
];

export default function parseCallLogFile(file: File): Promise<CallLogParseResult> {
	const extension = getFileExtension(file.name) ?? '';
	
	for (const handler of handlers) {
		if (handler.canParse(extension, file.type)) {
			return handler.parse(file);
		}
	}
	
	return Promise.resolve<CallLogParseResult>({ 
		type: 'error', 
		error: { type: 'unsupportedFileType' }
	});
}